import React from 'react';
import { Button, Row, Col, Card } from 'antd';
import { connect } from 'react-redux';
import { userActions } from '../../redux/actions/userAction'
const HomePage = (props) => {
    const isLogined = props.logined;
    const goToPage = (serviceTypeId) => {
        props.setCurrentServiceTypeId(serviceTypeId);
        console.log(props, 'props');
        props.history.push(isLogined && (((props.cc != undefined) ? props.cc.address.length : 0) > 1 || (props.lastAddress.length > 1)) ? '/registerService' : '/login');
    }
    const goToRegisterService=()=>{
        props.history.push('registerServicePublic')
    }    
    const goToRegisterCounsel=()=>{
        props.history.push('registerCounsel')
    } 
    return <div className="center newOuterContainer">

        <Row style={{ position: 'relative', top: '100px' }}>
            <Col xs={{ span: 18, offset: 3 }} lg={{ span: 8, offset: 8 }}>
                <Card>
                    <div style={{ textAlign: 'right', paddingBottom: '15px' }}>
                        <b>لطفا نوع درخواست خود را انتخاب نمایید</b>
                    </div>
                    <Button type="primary" danger shape="round" size='large' className='serviceType' block
                        //onClick={goToPage.bind(this, 3)}
                        onClick={goToRegisterService.bind(this)}                
                    >خدمات</Button>
                    <br />
                    <Button type="primary" danger shape="round" size='large' className='serviceType' block
                        // onClick={goToPage.bind(this, 2)}
                        onClick={goToRegisterCounsel.bind(this)}                        
                        >شکایت</Button>
                    <br />

                    {/* <Button type="primary" danger shape="round" size='large' className='serviceType' block
                      onClick={goToPage.bind(this,4)}>شکایت</Button> */}
                    <br />
                </Card>
            </Col>
        </Row>

    </div>
}
const mapStateToProps = state => ({
    logined: state.user.isAuthenticate,
    cc: state.user.currentCustomerInfo,
    lastAddress: state.user.currentUser.lastAddress,
});
const mapActionCreateor = {
    setCurrentServiceTypeId: userActions.setServiceType,
}
export default connect(mapStateToProps, mapActionCreateor)(HomePage)
